import { parseDomain } from '@wix/domains-serverless-interface';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { createApiClient, createQueriesConfig, QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra-react';
const apiConfig = createQueriesConfig({
  tldPromotionsWithPrice: {
    queryFn: async _ref => {
      let httpClient = _ref.httpClient,
        limit = _ref.request.limit;
      const _DomainsApiClient$que = DomainsApiClient.queries({
          httpClient
        }),
        listTldPromotions = _DomainsApiClient$que.listTldPromotions,
        listDisplayPrices = _DomainsApiClient$que.listDisplayPrices;
      const _await$listTldPromoti = await listTldPromotions({
          limit
        }),
        tldPromotions = _await$listTldPromoti.tldPromotions;
      if (!(tldPromotions != null && tldPromotions.length)) {
        return {
          tldPromotionsWithPrice: []
        };
      }
      try {
        var _displayPrices$filter;
        const _await$listDisplayPri = await listDisplayPrices({
            domains: (tldPromotions == null ? void 0 : tldPromotions.flatMap(_ref2 => {
              let tld = _ref2.tld;
              return typeof tld === 'string' ? [{
                domain: `example.${tld}`,
                premium: false
              }] : [];
            })) ?? []
          }, {
            useErrorBoundary: false
          }),
          displayPrices = _await$listDisplayPri.displayPrices;
        const displayPriceMap = Object.fromEntries((displayPrices == null || (_displayPrices$filter = displayPrices.filter(price => Boolean(price.domain))) == null ? void 0 : _displayPrices$filter.map(price => [parseDomain(price.domain ?? '').tld, price])) ?? []);
        const tldPromotionsWithPrice = (tldPromotions == null ? void 0 : tldPromotions.map(promotion => ({
          ...promotion,
          pricing: displayPriceMap[promotion.tld ?? ''] ?? {}
        }))) ?? [];
        return {
          tldPromotionsWithPrice
        };
      } catch (e) {
        return {
          tldPromotionsWithPrice: tldPromotions
        };
      }
    },
    queryConfigType: QueryConfigTypes.STATIC_DATA
  }
});
export const tldPromotionsApiClient = createApiClient(apiConfig);
//# sourceMappingURL=TldPromotionsWithPrice.apiClient.js.map